__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "relatedmedia";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@fancyapps/ui", "5.0.36", () => (__webpack_require__.e(60197).then(() => (() => (__webpack_require__(60197))))));
			register("@plone/registry", "2.5.0", () => (__webpack_require__.e(6176).then(() => (() => (__webpack_require__(6176))))));
			register("jquery-form", "4.3.0", () => (Promise.all([__webpack_require__.e(25022), __webpack_require__.e(64061)]).then(() => (() => (__webpack_require__(64061))))));
			register("jquery", "3.7.1", () => (__webpack_require__.e(74692).then(() => (() => (__webpack_require__(74692))))));
			register("slick-carousel", "1.8.1", () => (Promise.all([__webpack_require__.e(9599), __webpack_require__.e(25022)]).then(() => (() => (__webpack_require__(9599))))));
			register("underscore", "1.13.7", () => (__webpack_require__.e(4523).then(() => (() => (__webpack_require__(4523))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};